import { FC, useState, useEffect } from 'react';
import { Dropdown, type MenuProps } from 'antd';
import { UserOutlined, DownOutlined } from '@ant-design/icons';
import { useAuthContext } from 'context/AuthContext';
import { useLogout } from 'hooks/useAuth';
import useWindowDimensions from 'hooks/useWindowDimensions';
import { useRouteContext } from 'context/RouteContext';
import { MenuMobile } from './MenuMobile';

const UserMenu: FC = () => {
  const logout = useLogout();
  const { user } = useAuthContext();
  const { setPath, path } = useRouteContext();
  const { isMobile } = useWindowDimensions();
  const [activeMenuItem, setActiveMenuItem] = useState<string>();

  useEffect(() => {
    console.log({ user });
  }, [user]);

  const items: MenuProps['items'] = [
    {
      key: '/',
      label: 'Home',
      // onClick: () => setPath('/'),
    },
    {
      key: '/orders',
      label: 'Orders',
//       onClick: () => setPath('/orders'),
    },
    {
      key: '/discounts',
      label: 'Discounts',
//       onClick: () => setPath('/discounts'),
    },
    {
      key: '/services',
      label: 'Services',
      // onClick: () => setPath('/services'),
    },
    {
      key: '/feedback',
      label: 'Feedback',
      // onClick: () => setPath('/feedback'),
    },
    {
      key: '/meta',
      label: 'Meta',
      // onClick: () => setPath('/meta'),
    },
    {
      key: '/resources',
      label: 'Resources',
      // onClick: () => setPath('/resources'),
    },
    {
      key: '/settings',
      label: 'Settings',
      // onClick: () => setPath('/settings'),
    },
    {
      key: 'user-sign-out',
      label: 'Sign out',
      onClick: async () => await logout(),
    },
  ];

  useEffect(() => {
    console.log({ path });

    setActiveMenuItem(path?.split('/')[1]);
  }, []);

  const onClick: MenuProps['onClick'] = (e) => {
    console.log('click', e);
    // onClose();
    setPath(e.key);
    setActiveMenuItem(e.key);
  };

  return (
    (isMobile && <MenuMobile items={items} />) || (
      <Dropdown
        menu={{
          items,
          selectable: true,
          // defaultSelectedKeys: ['home'],
          onClick: onClick,
          activeKey: activeMenuItem,
        }}
        placement="bottomRight"
        arrow
      >
        <a
          href="/"
          className="ant-dropdown-link user-profile-menu-link"
          onClick={(e) => e.preventDefault()}
        >
          {/* Welcome aboard, */}
          <UserOutlined /> Hello,&nbsp;
          {user?.firstname}
          &nbsp;
          <DownOutlined />
          {/* <Avatar
                            src={
                              <Image
                                src={'/default-avatar.png'}
                                // fallback={'/default-avatar.png'} it doesn't work :/
                                preview={false}
                              />
                            }
                          /> */}
        </a>
      </Dropdown>
    )
  );
};

export { UserMenu };
